import { kindMeta } from "./awardKinds"

// A single award, taped in like a photo — the scan/photo up top, a handwritten
// caption below (its direction). A gold/silver/bronze corner badge marks the
// placement (if any); the kind (медаль/кубок/…) shows as a chip. Clicking opens
// the modal.
const AwardCard = ({ award, onOpen }) => {
  const open = (event) => {
    event.preventDefault()
    onOpen()
  }

  const meta = kindMeta(award.kind)

  return (
    <article className="entry entry--award">
      <a className="entry__photo-link" href={`/awards/${award.id}`} onClick={open} aria-label={award.direction_label}>
        {award.photo_url ? (
          <div className="entry__photo">
            <img src={award.photo_url} alt={award.direction_label} loading="lazy" decoding="async" />
          </div>
        ) : (
          <div className={`entry__photo entry__photo--blank award-blank award-blank--${award.kind}`}>
            <i className={`fa-solid ${meta.icon} award-blank__icon`} aria-hidden="true"></i>
            <span className="entry__blank-title">{award.direction_label}</span>
          </div>
        )}
        {award.place && (
          <span className={`award-place award-place--${award.place}`} title={`${award.place} місце`} aria-label={`${award.place} місце`}>
            {award.place}
          </span>
        )}
      </a>

      <div className="entry__caption">
        <a className="entry__title" href={`/awards/${award.id}`} onClick={open}>
          {award.direction_label}
        </a>
        <div className="entry__meta">
          <span className="entry__genre entry__kind">
            <i className={`fa-solid ${meta.icon}`} aria-hidden="true"></i> {meta.one}
          </span>
        </div>
      </div>
    </article>
  )
}

export default AwardCard
